import commaUp from '../../../assets/images/solution/government/comma-up.png'
import commaDown from '../../../assets/images/solution/government/comma-down.png'
import divide from '../../../assets/images/solution/government/divide.png'

import styles from './style.module.scss'

function SmartGovernment() {
    return (
        <div className={`solution-introduction-wrapper ${styles['smart-gover-wrapper']}`}>
            <div className={`banner ${styles['banner']}`}>
                <div className='title'>智慧政务</div>
                <div className={styles['content']}>政务大数据平台、一网统管城市运行中心、公共卫生应急处置平台、政务一体化服务平台等一系列解决方案</div>
            </div>
            <div className={`introduction-wrapper ${styles['introduction-wrapper']}`}>
                <p className='title'>方案简介</p>
                <div className={`introduction-title ${styles['introduction-title']}`}>
                    <div>
                        <img src={commaUp} alt="" />
                        <p>智慧政务</p>
                        <p>基于政府信息化建设和数字化转型的需求，烽火星空打造政务大数据平台、一网统管城市运行中心、公共卫生应急处置平台、政务一体化服务平台等一系列解决方案，助力各地数字政府的推进建设。</p>
                        <img src={commaDown} alt="" />
                    </div>
                </div>
            </div>
            <div className={styles['introduction-content']}>
                <div className={styles['introduction-item']}>
                    <div className={styles['img']}></div>
                    <p className={styles['sub-title']}>政数管理</p>
                    <p className={styles['sub-content']}>一站式解决政务数据的采、看、用、治、评</p>
                </div>
                <div className={styles['introduction-item']}>
                    <div className={styles['img']}></div>
                    <p className={styles['sub-title']}>一网统管</p>
                    <p className={styles['sub-content']}>打造“观管防”一体化平台，赋能城市运行日常管理</p>
                </div>
                <div className={styles['introduction-item']}>
                    <div className={styles['img']}></div>
                    <p className={styles['sub-title']}>专题分析</p>
                    <p className={styles['sub-content']}>构建专题指标体系，为精准扶贫、生态保护、卫生防疫等专题板块提供数据分析服务</p>
                </div>
                <div className={styles['introduction-item']}>
                    <div className={styles['img']}></div>
                    <p className={styles['sub-title']}>政务服务</p>
                    <p className={styles['sub-content']}>创新赋能基层服务新模式，提升企业、园区、民众满意度</p>
                </div>
            </div>
            <div className={styles['achievement-wrapper']}>
                <p className={styles['title']}>实践成果</p>
                <div className={styles['achievement-container']}>
                    <div className={styles['achievement-item']}>
                        <span className={styles['title']}>成都</span>
                        <span className={styles['sub-title']}>一网统管</span>
                        <img src={divide} alt="" />
                        <span className={styles['content']}>聚焦八大场景建设</span>
                        <span className={styles['content']}>构建”一网统管“新格局</span>
                    </div>
                    <div className={styles['achievement-item']}>
                        <span className={styles['title']}>襄阳</span>
                        <span className={styles['sub-title']}>一网统管</span>
                        <img src={divide} alt="" />
                        <span className={styles['content']}>”统“字发力</span>
                        <span className={styles['content']}>推动城市治理全方位变革</span>
                    </div>
                    <div className={styles['achievement-item']}>
                        <span className={styles['title']}>上海</span>
                        <span className={styles['sub-title']}>一网统管</span>
                        <img src={divide} alt="" />
                        <span className={styles['content']}>围绕”一屏观天下，一网管全城“</span>
                        <span className={styles['content']}>推进超大城市治理体系和治理能力现代化</span>
                    </div>
                    <div className={styles['achievement-item']}>
                        <span className={styles['title']}>佛山</span>
                        <span className={styles['sub-title']}>政务大数据平台</span>
                        <img src={divide} alt="" />
                        <span className={styles['content']}>为全市开放一体化数据服务</span>
                        <span className={styles['content']}>实现业务协同，支撑数字政府建设工作</span>
                    </div>
                    <div className={styles['achievement-item']}>
                        <span className={styles['title']}>徐汇</span>
                        <span className={styles['sub-title']}>一网统管</span>
                        <img src={divide} alt="" />
                        <span className={styles['content']}>打造可视化场景应用</span>
                        <span className={styles['content']}>提升基层治理能力</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SmartGovernment